import { BoxProps, Flex, forwardRef } from '@chakra-ui/react';

import { createUseVariantStyle } from '@bonusly/ds-hooks';

import { AlertContext } from '../context';
import { AlertSize, AlertStatus } from '../types';

export interface AlertProps extends BoxProps {
	size?: AlertSize;
	status?: AlertStatus;
}

const useVariantStyle = createUseVariantStyle({
	size: {
		sm: {
			fontSize: 'sm',
			px: 2,
			py: 1.5,
		},
		md: {
			fontSize: 'md',
			px: 3,
			py: 2,
		},
	},
	status: {
		info: {
			bg: 'info.bg',
		},
		success: {
			bg: 'success.bg',
		},
		warn: {
			bg: 'warning.bg',
		},
		warning: {
			bg: 'warning.bg',
		},
		error: {
			bg: 'error.bg',
		},
	},
});

const Alert = forwardRef(({ children, size = 'md', status = 'info', ...rest }: AlertProps, ref) => {
	const style = useVariantStyle({ size, status });

	return (
		<AlertContext value={{ size, status }}>
			<Flex data-status={status} borderRadius="md" columnGap={2} ref={ref} role="alert" pos="relative" w="full" {...style} {...rest}>
				{children}
			</Flex>
		</AlertContext>
	);
});

Alert.displayName = 'Alert';

export { Alert };
